import type {ReactElement} from 'react';
import React from 'react';
import {OnMyDesignSection} from '@Components/color-picker-v2/components/on-my-design-section';
import {BrandsSection} from '@Components/color-picker-v2/components/brands-section';
import {ColorPickerMobileSection} from '@Components/color-picker-mobile';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';
import {DefaultPresetSection} from '@Components/color-picker-mobile/components/default-preset-section';

interface SwatchesSectionProps {
  color: ColorStorage[];
  onMyDesign: string[];
  selectedIndex?: number;

  onToggleSection(newSection: ColorPickerMobileSection): void;

  onToggleSectionEnded?(newSection: ColorPickerMobileSection): void;

  onAddBrandAssetClicked?(): void;

  onChangeColor(color: ColorStorage[]): void;

  onChangeEnded(color: ColorStorage[]): void;
}

export function SwatchesSection({selectedIndex = 0, ...props}: SwatchesSectionProps): ReactElement {
  const onChangeHandler = (color: RGBA): void => {
    const newColor = props.color;
    newColor[selectedIndex].color = color;
    props.onChangeColor(newColor);
    props.onChangeEnded(newColor);
  };

  const onColorSelectFromBrands = (brandColor: RGBA): void => {
    onChangeHandler(brandColor);
  };

  return (
    <>
      <OnMyDesignSection
        colorsOnDesign={props.onMyDesign}
        isMobileVersion
        onClickAdd={(): void => {
          props.onToggleSection(ColorPickerMobileSection.HEXPICKER);
        }}
        onColorSelect={onChangeHandler}
      />
      <BrandsSection
        className="spacing-p-t-4"
        onAddBrandAssetClicked={(): void => {
          if (props.onAddBrandAssetClicked) {
            props.onAddBrandAssetClicked();
          }
        }}
        onColorSelect={onColorSelectFromBrands}
      />
      <DefaultPresetSection onChangeColor={onChangeHandler} className="spacing-p-t-4" />
    </>
  );
}
